import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Grid, Typography } from "@sumprio/ui";
import "./PageNotFound.scss";

export default function PageNotFound() {
  const history = useHistory();

  return (
    <div className="page-not-found">
      <Grid display="flex" flexDirection="column" alignItems="center" gap="lg">
        <div className="page-not-found__graphic" aria-hidden>
          404
        </div>
        <Typography variant="heading" headingSize="md" headingWeight="medium">
          Page Not Found
        </Typography>
        <Typography variant="body" bodySize="sm" bodyWeight="regular" color="secondary">
          The page you&apos;re looking for doesn&apos;t exist or may have been moved.
        </Typography>
        <Button variant="brand-default" size="md" onClick={() => history.goBack()}>
          Return To Previous Page
        </Button>
      </Grid>
    </div>
  );
}
